import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      header: {
        margin: theme.spacing(4, 0),
      },
    }),
  { name: 'ListagemLogins' }
);
